<template>
  <div class="page-container">
    <div class="search-container">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" @click="handleApplyRefund" :loading="isApplyLoading" :disabled="multipleSelection.length === 0" class="h40" plain>{{ $t('申请返款') }}</el-button>
        </el-form-item>
      </el-form>
      <el-form :inline="true">
        <el-form-item>
          <base-input-tag
            style="width:210px"
            v-model="searchParam.waybillNos"
            :placeholder="$t('请输入运单编号(最多可查200条)')"
            :clearBtnVisible="true"
            ref="BaseInputTag2"
            :addTagOnBlur="true"
            class="cms-input-tag"/>
        </el-form-item>
        <el-form-item>
          <base-input-tag
            style="width:230px"
            v-model="searchParam.customerOrderId"
            :placeholder="$t('请输入客户订单号(最多可查200条)')"
            :clearBtnVisible="true"
            ref="BaseInputTag3"
            :addTagOnBlur="true"
            validate="isSymbolNumberLetter"
            class="cms-input-tag">
          </base-input-tag>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="searchParam.date"
            type="daterange"
            :range-separator="$t('至')"
            :start-placeholder="$t('开始时间')"
            :end-placeholder="$t('结束时间')"
            class="commonSize"
            @change="selectDate"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchChange" icon="iconfont iconchaxun" class="h32">{{ $t('查询') }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="resetSearch" icon="iconfont iconshanchu" class="h32">{{ $t('清空') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--汇总-->
    <the-summary :params="searchParam" ref="theSummary"/>

    <!--实时合计-->
    <div class="table-summary">
      <span>{{ $t('本次共选中') }}: </span>
      <span class="summary-data">{{ $t('订单数量') }}: {{ multipleSelection.length }}</span>
      <span class="summary-data">{{ $t('COD订单金额') }}: {{ codOrderMoney }}</span>
      <span class="summary-data">{{ $t('客户手续费') }}: {{ customerFee }}</span>
      <span class="summary-data">{{ $t('应付客户金额') }}: {{ payAmount }}</span>
    </div>

    <div class="table-container">
      <div class="tabs-nav">
        <div class="tabs-nav-item"
             v-for="(item,index) in menuItems" :key="index"
             @click="handleTabChange(index, item.value)"
             :class="{'active': tabActiveIndex === index}">
          {{ item.name }}
        </div>
      </div>
      <JmsTable
        ref="table"
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @size-change="sizeChange"
        @select-all="handleSelectionChange"
        @select="handleSelectionChange"
        @current-change="currentChange">
      </JmsTable>
    </div>
  </div>
</template>

<script>
import { commonFun } from '@/utils/util'
import mixin from '@/mixins/mixin'
import JmsTable from '@/components/jms-widget/jms-table-scroll'
import { fetchApplyRefund, reqList } from '@/api/module/codRefund'
import TheSummary from '@/views/cod-refund/components/TheSummary'
import { RESPONSE_SUCCESS } from '@/constants'

export default {
  name: 'RefundApply',
  components: {
    TheSummary,
    JmsTable,
  },
  mixins: [mixin],
  data() {
    return {
      isApplyLoading: false, // 是否加载申请返款
      searchParam: {
        waybillNos: [], // 运单号
        customerOrderId: [], // 客户订单号
        date: commonFun.GetTodayDate(),
        startDate: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        endDate: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        customerRefund: 1,
      },
      COM_HTTP: {
        reqList: reqList,
      },
      menuItems: [
        { name: this.$t('待申请'), value: 1 },
        { name: this.$t('申请中'), value: 2 },
        { name: this.$t('已返款'), value: 3 }
      ], // tab菜单
      tabActiveIndex: 0,
      multipleSelection: [],
    }
  },
  computed: {
    listOpt() {
      return {
        border: true,
        selection: this.tabActiveIndex === 0,
        menu: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        showTooltip: false,
        rowKey: 'id',
        fixHeight: 200,
        menuWidth: 150,
        column: [
          {
            label: this.$t('客户订单号'),
            prop: 'customerOrderId',
            width: 160,
          },
          {
            label: this.$t('运单号'),
            prop: 'waybillNo',
            width: 160,
          },
          {
            label: this.$t('返款机构'),
            prop: 'refundMechanism',
          },
          {
            label: this.$t('寄件网点'),
            prop: 'sendNetworkName',
          },
          {
            label: this.$t('返款网点'),
            prop: 'codRebateNetworkName',
          },
          {
            label: this.$t('货款金额'),
            prop: 'collectionfee',
          },
          {
            label: this.$t('客户手续费'),
            prop: 'customerFee',
            width: 100,
            formatter: row => row.customerFee || '0'
          },
          {
            label: this.$t('应付客户金额'),
            prop: 'amountPayable',
            width: 100
          },
          {
            label: this.$t('返款时间'),
            prop: 'refundTime',
            show: this.tabActiveIndex === 2
          },
          {
            label: this.$t('签收时间'),
            prop: 'signTime',
          },
          {
            label: this.$t('签收网点名称'),
            prop: 'signNetworkName',
            width: 200
          },
          {
            label: this.$t('签收标识'),
            prop: 'isSign',
            formatter: (row) => {
              return row.isSign === 1 ? this.$t('是') : this.$t('否')
            },
          },
          {
            label: this.$t('退件标识'),
            prop: 'isRefund',
            formatter: (row) => {
              return row.isRefund === 1 ? this.$t('是') : this.$t('否')
            },
          },
        ],
      }
    },
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    codOrderMoney() {
      let total = 0
      this.multipleSelection.forEach(item => (total += item.collectionfee))
      return parseFloat(total).toFixed(2)
    },
    customerFee() {
      let total = 0
      this.multipleSelection.forEach(item => (total += item.customerFee))
      return parseFloat(total).toFixed(2)
    },
    payAmount() {
      let total = 0
      this.multipleSelection.forEach(item => (total += item.amountPayable))
      return parseFloat(total).toFixed(2)
    }
  },
  methods: {
    getParams() {
      const { customerOrderId, startDate, endDate, waybillNos, customerRefund } = this.searchParam

      return {
        timeType: 3,
        customerRefund: customerRefund,
        startTime: startDate,
        endTime: endDate, // 结束日期
        customerOrderId: customerOrderId.toString() || null, // 客户订单
        waybillNos: waybillNos // 运单号
      }
    },
    /**
     * 筛选查询
     * @param params
     */
    async searchChange(params) {
      const { startDate, endDate } = this.searchParam
      const space = 15 * 24 * 3600 * 1000
      const startTime = new Date(startDate).getTime()
      const endTime = new Date(endDate).getTime()
      if ((endTime - startTime) > space) return this.$message.error(this.$t('开始时间与结束时间之差不能大于15天'))
      // 处理订单编号
      const { waybillNos, customerOrderIds } = this.searchParam
      // 处理运单编号
      if (waybillNos && waybillNos.length > 200) return this.$message.warning(this.$t('请勿超过200条运单'))
      // 处理客户订单号
      if (customerOrderIds && customerOrderIds.length > 200) return this.$message.warning(this.$t('请勿超过200条客户订单'))
      // 列表查询
      this.searchFun(1)
      this.$refs['theSummary'].loadData()
      // 列表总数查询
      this.multipleSelection = []
    },
    /**
     * 单个选中
     * @param val
     * @param currentRow
     */
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    /**
     * 选择日期
     */
    selectDate() {
      if (!this.searchParam.date) {
        return
      }
      const [start = '', end = ''] = this.searchParam.date
      this.searchParam.startDate = start
      this.searchParam.endDate = end
    },
    /**
     * tab切换
     * @param index
     * @param value
     */
    handleTabChange(index, value) {
      this.tabActiveIndex = index
      this.searchParam.customerRefund = value
      this.page.current = 1
      this.multipleSelection = []
      this.searchFun()
    },
    /**
     * 处理申请返款
     * @returns {Promise<void>}
     */
    async handleApplyRefund() {
      if (this.multipleSelection.length === 0) return

      const ids = this.multipleSelection.map(item => item.id)
      const { code, data, msg } = await fetchApplyRefund({
        ids: ids
      })
      if (code === RESPONSE_SUCCESS && data === true) {
        this.$message.success(this.$t('J&T已收到您的申请，请耐心等待'))
        await this.searchFun(1)
      } else {
        this.$message.error(this.$t(msg))
      }
    },
    /**
     * 重置搜索
     */
    resetSearch() {
      this.page.current = 1
      this.searchParam = {
        waybillNos: [], // 运单号
        customerOrderId: '', // 客户订单号
        date: commonFun.GetTodayDate(),
        startDate: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        endDate: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        customerRefund: 1,
      }
    },
    /**
     * 查询成功后回调
     */
    searchAfterFun() {
      this.$nextTick(() => {
        if (this.$refs['table']) {
          this.$refs['table'].$refs['table'].doLayout()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {

  .search-container {
    padding: 12px 24px;
  }

  .table-summary {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    height: 45px;
    background-color: #eef9e8;
    color: #61c92e;
    margin-top: 30px;

    .summary-data {
      margin: 0 10px;
    }
  }

  .table-container {
    padding: 12px 24px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    background: #edeef3;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;

    .tabs-nav {
      .tabs-nav-item {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        border: 1px solid #dcdfe6;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: none;
        transition: 0.1s;
        font-weight: 500;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        padding: 12px 20px;
        font-size: 16px;
        background: #e0e1e7;
        height: 40px;
        border-radius: 8px 8px 0 0;
        color: #666;
        margin: 0 0 0 10px;

        &:first-of-type {
          margin-left: 0;
        }

        &.active {
          border: 1px solid #ffffff;
          background: #ffffff;
          color: #e60012;
        }
      }
    }
  }
}
</style>
